<template>
    <section id="client" class="client">
        <div class="container">
            <h3 class="client-title">
                {{ $t('client.main_title') }}
            </h3>
            <div class="content">
                <carousel dir="ltr" easing="linear" :paginationEnabled="false" :loop="true" :autoplay="true" :autoplayTimeout="4000"
                    :scrollPerPage="false" :navigationEnabled="true" :perPage="size" v-scrollanimation>
                    <slide v-for="(item, index) in $store.state.client_data" :key="index">
                        <div class="logo" >
                            <img :src="item.image[0]" class="client-logo" :alt="item.name" />
                            <h5 style="color: var(--main-blue);">
                                {{item.name}}
                            </h5>
                        </div>
                    </slide>
                </carousel>
            </div>
        </div>
    </section>
</template>

<script>


export default {
    name: "Client",
    components: {

    },
    data() {
        return {
            screenWidth: 0,
            size: 0,
            client_data: [
                {
                    name: "Wlcd Academy",
                    image: "acad.png",
                },
                {
                    name: "Ararat",
                    image: "ararat.png",
                },
                {
                    name: "Bee Taxi",
                    image: "bee_taxi.png",
                },
                {
                    name: "Diamond Line",
                    image: "diamond.png",
                },
                {
                    name: "Halal",
                    image: "halal.png",
                },
                {
                    name: "Halal Academy",
                    image: "halal_acad.png",
                },
                {
                    name: "Khalilak",
                    image: "khalilak.png",
                },
                {
                    name: "Hiba",
                    image: "new_hiba.png",
                },
                {
                    name: "Unicorn",
                    image: "unicorn.png",
                },
                {
                    name: "اسألني",
                    image: "اسالني.png",
                },
                {
                    name: "يد التضامن",
                    image: "يد التضامن.png",
                },
            ]
        };
    },
    methods: {
        getImage(item){
            return require("@/assets/img/client/" + item.image)
        },
        onScreenResize() {
            window.addEventListener("resize", () => {
                this.updateScreenWidth();
            });
        },
        updateScreenWidth() {
            this.screenWidth = window.innerWidth
        },
        setSize() {
            if (this.screenWidth >= '992')
                this.size = 4
            else if (this.screenWidth < 991 && this.screenWidth >= 767)
                this.size = 2
            else
                this.size = 1
        },
    },
    created() {
        this.updateScreenWidth()
        this.onScreenResize()
        this.setSize()
        console.log(this.$store.state.client_data)
        // console.log(this.size)
    }
};
</script>

<style lang="scss">
.client {
    padding: 60px 100px 80px;
    background-color: rgba(231, 231, 231, 0.356);
}

@media (max-width: 991px) {
    .client {
        padding: 60px 30px 80px;
    }
}

.client .client-title {
    text-align: center;
    font-size: 35px;
    font-weight: bold;
    color: var(--main-blue);
    margin-bottom: 60px;
}

.client .VueCarousel-dot[data-v-438fd353]:focus {
    outline: none;
}

.client .VueCarousel-navigation-button[data-v-453ad8cd] {
    padding: 10px !important;
    color: var(--main-blue)
}

.client .VueCarousel-navigation-button[data-v-453ad8cd]:focus {
    outline: none;
}

.client .VueCarousel-slide {
    padding: 10px
}

.client .client-logo {
    height: 70px;
}

.client .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 150px;
    box-shadow: 0px 0px 10px rgb(106 106 106 / 40%);
    background: #fff;
    border-radius: 10px;
    flex-direction: column;
    row-gap: 10px;
    padding: 20px;
}

.client .before-enter {
    opacity: 0;
    transform: translateY(100px);
    transition: all 1s ease-out;
}

.client .enter {
    opacity: 1;
    transform: translateY(0px);
}
</style>